/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceTabletQuestion = createReactComponent("outline", "device-tablet-question", "IconDeviceTabletQuestion", [["path", { "d": "M15 21h-9a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-3" }]]);

export { IconDeviceTabletQuestion as default };
//# sourceMappingURL=IconDeviceTabletQuestion.mjs.map
